module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-31.42a0abb4.png";